// Cloudflare Turnstile Site Key (public key - safe to hardcode)
export const TURNSTILE_SITE_KEY = "0x4AAAAAACabRO0JDSCj6fu1";

// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || "";

// App Store URLs
export const IOS_STORE_URL =
  "https://apps.apple.com/vn/app/phuong/id6745983307?l=vi";
export const ANDROID_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.phuong.ai";
